import React from 'react';
import { connect } from "react-redux";
import { getLanguage } from '../../store/apiWrapper';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { Translate, withLocalize } from "react-localize-redux";
import moment from "moment";

import '../../css/cookieConsent.scss';

class PrivacyPolicyInfoComponent extends React.Component {
    render() {
        var agentLanguage = "";
        if (!isNullOrUndefined(this.props.user) &&
            !isNullOrUndefined(this.props.user.authentication) &&
            !isNullOrUndefined(this.props.user.authentication.profile) &&
            !isNullOrUndefined(this.props.user.authentication.profile.agentLanguage))
            agentLanguage = this.props.user.authentication.profile.agentLanguage;
        else
            agentLanguage = getLanguage();

        var country = agentLanguage === 'sk-SK' ? 'SK' : 'CZ';
        var crifInfo = this.props.translate(`PersonalData.Crif.${country}.Info`);
        var law = this.props.translate(`PersonalData.Cribis.${country}.Law`);
        var helpdesk = agentLanguage === 'sk-SK' ? 'helpdesk.sk@crif.com' : 'helpdesk.cz@crif.com';

        return (
            <div className='cookie-info-content content'>
                <h1 style={{ marginTop: "1em" }}><Translate id='PersonalData.Cribis' /></h1>
                <div className="rating-update-info">
                    <Translate id="PersonalData.Date" data={{ 0: moment(new Date(2020, 2, 1)).format("l") }}></Translate>
                </div>
                <Translate id='PersonalData.Cribis.Content' options={{ renderInnerHtml: true }} data={{ country, crifInfo, law, helpdesk }} />
            </div>
        );
    }
}

export default withLocalize(connect(
    state => ({ user: state.userContext }))(PrivacyPolicyInfoComponent));